// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanDeleteAgents } from "./hook";

export type CanDeleteAgentsProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanDeleteAgents({
  children,
  fallback,
  scope,
}: CanDeleteAgentsProps) {
  const canDoAction = useCanDeleteAgents(scope);
  return <>{canDoAction ? children : fallback}</>;
}
